import client from "./client";
import { cacheDelete, TTL, userCacheKey } from "../lib/cache";
import { fetchCached } from "./fetchCached";

export const CVE_METRICS_KEY = (user) => userCacheKey(user, "cves:metrics");
export const CVE_LIST_KEY = (user) => userCacheKey(user, "cves:list");

export function invalidateCves(user) {
  cacheDelete(CVE_METRICS_KEY(user));
  cacheDelete(CVE_LIST_KEY(user));
}

/**
 * @param {object|null} user
 * @param {{ revalidate?: boolean }} [opts]
 */
export async function getCveMetrics(user, { revalidate = false } = {}) {
  const key = CVE_METRICS_KEY(user);
  const { data } = await fetchCached({
    key,
    ttl: TTL.CVE_METRICS,
    revalidate,
    fetcher: async () => {
      const res = await client.get("/me/cves/metrics");
      return res.data;
    },
  });
  return data;
}

/**
 * @param {object|null} user
 * @param {{ revalidate?: boolean }} [opts]
 */
export async function listCves(user, { revalidate = false } = {}) {
  const key = CVE_LIST_KEY(user);
  const { data } = await fetchCached({
    key,
    ttl: TTL.CVE_LIST,
    revalidate,
    fetcher: async () => {
      const res = await client.get("/me/cves");
      return res.data;
    },
  });
  return data;
}
